import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import axios from "axios";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Paginator } from "primereact/paginator";
import { Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import * as Designations from "../../enums/Designations";
import * as FlightBookingStatus from "../../enums/BookingStatus";
import * as Genders from "../../enums/Genders";
import * as Travelmodes from "../../enums/Travelmodes";
import LoadingSpinner from "../Spinner/LoadingSpinner";
import { useHistory } from "react-router-dom";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import exportData from "../../services/exportToExcelService";
import AccessControl from "../AccessControl";
import NoAccess from "../NoAccess";
import userDetails from "../../services/userTokenDetails";
import { RowsPerPageDropdown } from "../../enums/RowsPerPageOptions";
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";

const TravelSummary = () => {
    // Hooks
    const [filterDialog, setFilterDialog] = useState(false);
    const [participantlist, setParticipantlist] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedParticipant, setSelectedParticipant] = useState(null);
    const [id, setid] = useState(new Array());
    const [userObj, setUsrObj] = useState(new Array());
    const [ActionDisable, setActionDisable] = useState(true);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [fullName, setfullName] = useState(null);
    const [filterEmail, setFilterEmail] = useState(null);
    const [filterMobileNo, setFilterMobileNo] = useState(null);
    const [filterBoardingCity, setFilterBoardingCity] = useState(null);
    const [filterHospitalName, setFilterHospitalName] = useState(null);
    const [filterCompany, setFilterCompany] = useState(null);
    const [filterCity, setFilterCity] = useState(null);
    const [filterState, setFilterState] = useState(null);
    const [filterCountry, setFilterCountry] = useState(null);
    const [filterInBatchBooking, setFilterInBatchBooking] = useState(null);
    const [filterOutBatchBooking, setFilterOutBatchBooking] = useState(null);
    const [CancellationDialog, setCancellationDialog] = useState(false);
    const [CancellationRemarks, setCancellationRemarks] = useState(null);
    const [Cancellationfor, setCancellationfor] = useState(null);
    const [HotelFilter, setHotelFilter] = useState(null);
    const [SerialNumber, setSerialNumber] = useState(null);
    const [ApiHeaders, setApiHeaders] = useState(null);
    const [WhatsAppUrlData, setWhatsAppUrlData] = useState(null);
    const [WhatsappStatus, setWhatsAppStatus] = useState(null);
    const [SeemamamNo, setSeemamamNo] = useState(null);
    const [companyList, setCompanyList] = useState([]);
    const [tricoConfirmedList, setTricoConfirmedList] = useState([]);
    const [cancelledTemplate, setcancelledTemplate] = useState([]);
    const [eventMedium, setEventMedium] = useState([]);
    const UserName = localStorage.getItem("Username");
    const WhatsAppMessageStatus = useRef({
        Doctor: null,
        FieldPerson: null,
        Admin: null,
    });

    // Const
    const toast = useRef(null);
    const dt = useRef(null);
    const history = useHistory();
    var company = localStorage.getItem("Company");
    const CompanyId = localStorage.getItem("CompanyId");
    var usrDetails = userDetails();

    const lazyState = useRef({
        first: 0,
        rows: RowsPerPageDropdown[0],
        page: 1,
        sortField: null,
        sortOrder: null,
        filterDesignation: null,
        filterGender: null,
        filterToEventCity: null,
        filterFromEventCity: null,
        filterCity: null,
        filterState: null,
        filterCountry: null,
        fullName: null,
        filterHospitalName: null,
        filterEmail: null,
        filterMobileNo: null,
        filterCompany: null,
        filterInFlightBookingStatus: null,
        filterOutFlightBookingStatus: null,
        filterInBatchBooking: null,
        filterOutBatchBooking: null,
        filterTravelRemarks: null,
        filterBoardingCity: null,
        filterCompany: null,
        TricoConfirmedfilter: null,
    }); // For Sorting And Pagination Purpose

    // On Screen Load
    useEffect(() => {
        getparticipantlist();
        getData();
        getFilterListsData();
        if (window.innerWidth > 991) {
            document.documentElement.style.setProperty("overflow", "hidden");
        } else {
            document.documentElement.style.setProperty("overflow", "auto");
        }
        return () => {
            document.documentElement.style.setProperty("overflow", "auto");
        };
    }, []);

    // Get All Participants
    const getparticipantlist = (isExportExcel = false, event) => {
        //Company
        var listCompanyFilterString = null;
        if (lazyState.current.CompanyFilter != null && lazyState.current.CompanyFilter != undefined && lazyState.current.CompanyFilter != "") {
            if (lazyState.current.CompanyFilter.length > 0) {
                if (lazyState.current.CompanyFilter.length > 1) {
                    listCompanyFilterString = lazyState.current.CompanyFilter.map((item) => item.name).join(",");
                } else {
                    listCompanyFilterString = lazyState.current.CompanyFilter.map((item) => item.name)[0];
                }
            }
        }

        //Trico Confirmed Batch
        var listTricoConfirmedFilterString = null;
        if (lazyState.current.TricoConfirmedfilter != null && lazyState.current.TricoConfirmedfilter != undefined && lazyState.current.TricoConfirmedfilter != "") {
            if (lazyState.current.TricoConfirmedfilter.length > 0) {
                if (lazyState.current.TricoConfirmedfilter.length > 1) {
                    listTricoConfirmedFilterString = lazyState.current.TricoConfirmedfilter.map((item) => item.name).join(",");
                } else {
                    listTricoConfirmedFilterString = lazyState.current.TricoConfirmedfilter.map((item) => item.name)[0];
                }
            }
        }
        setIsLoading(true);
        if (!isExportExcel) setParticipantlist([]);
        axios
            .post("/api/Participant/GetAll", {
                PaginationRequired: !isExportExcel,
                SortDirection: lazyState.current.sortOrder,
                PageSize: lazyState.current.rows,
                CurrentPageNumber: event && event.rows ? event.first / event.rows + 1 : lazyState.current.page,
                SortField: event && event.sortField ? event.sortField : "Firstname",
                registrationStatus: "APPROVED",
                CompanyFilter: listCompanyFilterString ? listCompanyFilterString : null,
                CompanyWiseFilter: usrDetails.role === "MR" || usrDetails.role === "SUBMR" ? CompanyId : null, // For Mr & Sub Mr Login
                FullName: lazyState.current.fullName ? lazyState.current.fullName.trim() : null,
                HospitalName: lazyState.current.filterHospitalName ? lazyState.current.filterHospitalName.trim() : null,
                Email: lazyState.current.filterEmail ? lazyState.current.filterEmail.trim() : null,
                MobileNo: lazyState.current.filterMobileNo ? lazyState.current.filterMobileNo.trim() : null,
                // CompanyFilter: lazyState.current.filterCompany ? lazyState.current.filterCompany : '',
                Designation: lazyState.current.filterDesignation ? lazyState.current.filterDesignation.code.trim() : null,
                Gender: lazyState.current.filterGender ? lazyState.current.filterGender.code.trim() : null,
                BoardingCity: lazyState.current.filterBoardingCity ? lazyState.current.filterBoardingCity.trim() : null,
                ToEventCity: lazyState.current.filterToEventCity ? lazyState.current.filterToEventCity.code.trim() : null,
                FromEventCity: lazyState.current.filterFromEventCity ? lazyState.current.filterFromEventCity.code.trim() : null,
                City: lazyState.current.filterCity ? lazyState.current.filterCity.trim() : null,
                State: lazyState.current.filterState ? lazyState.current.filterState.trim() : null,
                Country: lazyState.current.filterCountry ? lazyState.current.filterCountry.trim() : null,
                TicketOutFlightBookingStatus: lazyState.current.filterOutFlightBookingStatus ? lazyState.current.filterOutFlightBookingStatus.code.trim() : "APPROVED",
                TicketInFlightBookingStatus: lazyState.current.filterInFlightBookingStatus ? lazyState.current.filterInFlightBookingStatus.code.trim() : "APPROVED",
                OutBatchBooking: lazyState.current.filterOutBatchBooking ? lazyState.current.filterOutBatchBooking.trim() : null,
                InBatchBooking: lazyState.current.filterInBatchBooking ? lazyState.current.filterInBatchBooking.trim() : null,
                SerialNumber: lazyState.current.serialnumber ? lazyState.current.serialnumber.trim() : null,
                HotelFilter: lazyState.current.HotelFilter ? lazyState.current.HotelFilter.trim() : null,
                Ticket_Travel_mode_Inbound: "By Air",
                Ticket_Travel_mode_Outbound: "By Air",
                ParticipantHotel: true,
                TricoConfirmed: listTricoConfirmedFilterString ? listTricoConfirmedFilterString : null,
            })
            .then((Response) => {
                if (!isExportExcel) setParticipantlist([]);
                let tempData = [];
                if (Response.data.data != null) {
                    for (let dataObj of Response.data.data) {
                        // Pass body data in excelsheets.
                        let allExcelData;
                        let excelcolumnData = {
                            Id: dataObj.serialNumber,
                            Name: dataObj.fullName,
                            // Email: dataObj.email,
                            Company: dataObj.company,
                            TricoConfirmed: dataObj.tricoConfirmed,
                            InFlightStatus: dataObj.inFlightBookingStatus,
                            OutFlightStatus: dataObj.outFlightBookingStatus,
                            InBatch: dataObj.inBatchBooking,
                            OutBatch: dataObj.outBatchBooking,
                            Hotel: dataObj.hotelName,
                            // Hospital: dataObj.hospitalName,
                            // "MobileNo": dataObj.mobileNo,
                            // "To Event City": dataObj.travelmode_Inbound,
                            // "From Event City": dataObj.travelmode_Outbound,
                        };
                        if (selectedColumns.length > 0) {
                            for (let selectedColumn of selectedColumns) {
                                let fieldName = selectedColumn.field;
                                let headerName = selectedColumn.header;
                                excelcolumnData = { ...excelcolumnData, [headerName]: dataObj[fieldName] };
                            }
                            tempData.push(excelcolumnData);
                        } else {
                            allExcelData = {
                                Id: dataObj.serialNumber,
                                Name: dataObj.fullName,
                                Company: dataObj.company,
                                TricoConfirmed: dataObj.tricoConfirmed,
                                InFlightStatus: dataObj.inFlightBookingStatus,
                                OutFlightStatus: dataObj.outFlightBookingStatus,
                                InBatch: dataObj.inBatchBooking,
                                OutBatch: dataObj.outBatchBooking,
                                Hotel: dataObj.hotelName,
                                // Email: dataObj.email,
                                // Company: dataObj.company,
                                // Hospital: dataObj.hospitalName,
                                // "MobileNo": dataObj.mobileNo,
                                // "To Event City": dataObj.travelmode_Inbound,
                                // "From Event City": dataObj.travelmode_Outbound,
                            };
                            tempData.push(allExcelData);
                        }
                    }
                    if (isExportExcel == true) {
                        exportData(tempData, "Travel Summary");
                        setIsLoading(false);
                        return false;
                    }
                    setTotalRecords(Response.data.totalRecords);
                    setParticipantlist(Response.data.data);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current?.show({ severity: "error", summary: "Error", detail: "Oops! Something Went Wrong!", life: 3000 });
            });
    };

    const getFilterListsData = () => {
        setIsLoading(true);
        axios
            .get("/api/Participant/GetAllFilterListData")
            .then((Response) => {
                const separatedLists = Response.data.reduce((acc, item) => {
                    // Create a new array for each type if it doesn't exist
                    if (!acc[item.type]) {
                        acc[item.type] = [];
                    }
                    // Push the formatted item to the respective array
                    acc[item.type].push({ name: item.name, code: item.name });
                    return acc;
                }, {});

                // Sort each list by 'name'
                Object.keys(separatedLists).forEach((type) => {
                    separatedLists[type].sort((a, b) => a.name.localeCompare(b.name));
                });
                setCompanyList(separatedLists.Company || []);
                setTricoConfirmedList(separatedLists.TricoConfirmed || []);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current?.show({ severity: "error", summary: "Error", detail: "Oops! Something Went Wrong!", life: 3000 });
            });
    };

    // For Sorting
    const onSort = (event) => {
        lazyState.current.sortField = event.sortField;
        lazyState.current.sortOrder = event.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getparticipantlist(false, lazyState.current);
    };

    //pagination
    const onBasicPageChange = (event) => {
        // const newPage = event.first / event.rows + 1;
        // if (newPage !== lazyState.current.first / lazyState.current.rows + 1) {
        setIsLoading(true);
        lazyState.current.sortField = lazyState.current.sortField;
        lazyState.current.sortOrder = lazyState.current.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getparticipantlist(false, lazyState.current);
        setIsLoading(false);
        // };
    };

    //Template for pagination
    const template2 = {
        layout: " CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
        CurrentPageReport: (options) => {
            return (
                <span className="paginator-current-report" style={{ color: "var(--text-color)", userSelect: "none", textAlign: "center" }}>
                    Showing {options.first} to {options.last} of {options.totalRecords} entries
                </span>
            );
        },
        RowsPerPageDropdown: (options) => {
            return (
                <span className="paginator-rows-per-page">
                    Items Per Page :<Dropdown value={options.value} options={RowsPerPageDropdown} onChange={options.onChange} />
                </span>
            );
        },
    };

    const UserFilterOnEnter = (e) => {
        if (e.key == "Enter") {
            if (e.target.value.trim() != null && e.target.value.trim() != "") {
                setIsLoading(true);
                let data = e.target.id;
                switch (data) {
                    case "fullName":
                        lazyState.current.fullName = e.target.value ? e.target.value : null;
                        break;
                    case "hospital":
                        lazyState.current.filterHospitalName = e.target.value ? e.target.value : null;
                        break;
                    case "company":
                        lazyState.current.filterCompany = e.target.value ? e.target.value : null;
                        break;
                    case "Designation":
                        lazyState.current.filterDesignation = e.target.value ? e.target.value : null;
                        break;
                    case "Email":
                        lazyState.current.filterEmail = e.target.value ? e.target.value : null;
                        break;
                    case "MobileNo":
                        lazyState.current.filterMobileNo = e.target.value ? e.target.value : null;
                        break;
                    case "city":
                        lazyState.current.filterCity = e.target.value ? e.target.value : null;
                        break;
                    case "state":
                        lazyState.current.filterState = e.target.value ? e.target.value : null;
                        break;
                    case "country":
                        lazyState.current.filterCountry = e.target.value ? e.target.value : null;
                        break;
                    // case "ToEventCity":
                    //     lazyState.current.filterToEventCity = e.target.value ? e.target.value : null
                    //     break;
                    // case "FromEventCity":
                    //     lazyState.current.filterFromEventCity = e.target.value ? e.target.value : null
                    //     break;
                    case "boardingcity":
                        lazyState.current.filterBoardingCity = e.target.value ? e.target.value : null;
                        break;
                    case "outFlightBookingStatus":
                        lazyState.current.filterOutFlightBookingStatus = e.target.value ? e.target.value : null;
                        break;
                    case "inFlightBookingStatus":
                        lazyState.current.filterInFlightBookingStatus = e.target.value ? e.target.value : null;
                        break;
                    case "inBatchBooking":
                        lazyState.current.filterInBatchBooking = e.target.value ? e.target.value : null;
                        break;
                    case "outBatchBooking":
                        lazyState.current.filterOutBatchBooking = e.target.value ? e.target.value : null;
                        break;
                    case "serialnumber":
                        lazyState.current.serialnumber = e.target.value ? e.target.value : null;
                        break;

                    case "Hotel":
                        lazyState.current.HotelFilter = e.target.value ? e.target.value : null;
                        break;
                    case "TricoConfirmed":
                        lazyState.current.TricoConfirmedfilter = e.target.value ? e.target.value : null;
                        break;
                }
                getparticipantlist(false, lazyState.current);
                setIsLoading(false);
            } else {
                setIsLoading(true);
                let data = e.target.id;
                switch (data) {
                    case "fullName":
                        lazyState.current.fullName = null;
                        break;
                    case "hospital":
                        lazyState.current.filterHospitalName = null;
                        break;
                    case "company":
                        lazyState.current.filterCompany = null;
                        break;
                    case "Designation":
                        lazyState.current.filterDesignation = null;
                        break;
                    case "Email":
                        lazyState.current.filterEmail = null;
                        break;
                    case "MobileNo":
                        lazyState.current.filterMobileNo = null;
                        break;
                    case "city":
                        lazyState.current.filterCity = null;
                        break;
                    case "state":
                        lazyState.current.filterState = null;
                        break;
                    case "country":
                        lazyState.current.filterCountry = null;
                        break;
                    // case "ToEventCity":
                    //     lazyState.current.filterToEventCity = null
                    //     break;
                    // case "FromEventCity":
                    //     lazyState.current.filterFromEventCity = null
                    //     break;
                    case "boardingcity":
                        lazyState.current.filterBoardingCity = null;
                        break;
                    case "outFlightBookingStatus":
                        lazyState.current.filterOutFlightBookingStatus = null;
                        break;
                    case "inFlightBookingStatus":
                        lazyState.current.filterInFlightBookingStatus = null;
                        break;
                    case "inBatchBooking":
                        lazyState.current.filterInBatchBooking = null;
                        break;
                    case "outBatchBooking":
                        lazyState.current.filterOutBatchBooking = null;
                        break;
                    case "serialnumber":
                        lazyState.current.serialnumber = null;
                        break;
                    case "Hotel":
                        lazyState.current.HotelFilter = null;
                        break;
                    case "TricoConfirmed":
                        lazyState.current.TricoConfirmedfilter = null;
                        break;
                }
                getparticipantlist(false, lazyState.current);
                setIsLoading(false);
            }
        }
    };

    const SerialNumberFilterTemplate = () => {
        return <InputText id="serialnumber" value={SerialNumber} placeholder="Sr No." onChange={(e) => setSerialNumber(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "5rem" }} />;
    };

    const HotelFilterTemplate = () => {
        return <InputText id="Hotel" value={HotelFilter} placeholder="Enter Hotel" onChange={(e) => setHotelFilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "12rem" }} />;
    };

    const UserFilterTemplate = () => {
        return <InputText id="fullName" autoFocus value={fullName} placeholder="Enter FirstName" onChange={(e) => setfullName(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const InFlightBookingFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.filterInFlightBookingStatus}
                options={FlightBookingStatus.BookingStatus}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.filterInFlightBookingStatus = e.target.value ? e.target.value : null;
                    getparticipantlist({ InFlightBookingStatus: e.value });
                    e.preventDefault();
                }}
                placeholder="InFlight Status"
                className="p-column-filter"
                style={{ width: "200px" }}
            />
        );
    };

    const OutFlightBookingFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.filterOutFlightBookingStatus}
                options={FlightBookingStatus.BookingStatus}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.filterOutFlightBookingStatus = e.target.value ? e.target.value : null;
                    getparticipantlist({ OutFlightBookingStatus: e.value });
                    e.preventDefault();
                }}
                placeholder="OutFlight Status"
                className="p-column-filter"
                style={{ width: "200px" }}
            />
        );
    };

    const InBatchBookingFilterTemplate = () => {
        return <InputText id="inBatchBooking" value={filterInBatchBooking} placeholder="Enter InBatch Booking" onChange={(e) => setFilterInBatchBooking(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ width: "200px" }} />;
    };

    const OutBatchBookingFilterTemplate = () => {
        return <InputText id="outBatchBooking" value={filterOutBatchBooking} placeholder="Enter OutBatch Booking" onChange={(e) => setFilterOutBatchBooking(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ width: "200px" }} />;
    };

    const DesignationFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.filterDesignation}
                options={Designations.Designation}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.filterDesignation = e.target.value ? e.target.value : null;
                    getparticipantlist();
                    e.preventDefault();
                }}
                placeholder="Select Designation"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const GenderFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.filterGender}
                options={Genders.Gender}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.filterGender = e.target.value ? e.target.value : null;
                    getparticipantlist();
                    e.preventDefault();
                }}
                placeholder="Select Gender"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const ToEventCityTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.filterToEventCity}
                id="ToEventCity"
                options={Travelmodes.Travelmode}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.filterToEventCity = e.target.value ? e.target.value : null;
                    getparticipantlist();
                    e.preventDefault();
                }}
                placeholder="Select TravelMode "
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const FromEventCityTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.filterFromEventCity}
                id="FromEventCity"
                options={Travelmodes.Travelmode}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.filterFromEventCity = e.target.value ? e.target.value : null;
                    getparticipantlist();
                    e.preventDefault();
                }}
                placeholder="Select TravelMode"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const CityTemplate = () => {
        return <InputText id="city" value={filterCity} placeholder="Enter City" onChange={(e) => setFilterCity(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const StateTemplate = () => {
        return <InputText id="state" value={filterState} placeholder="Enter State" onChange={(e) => setFilterState(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const CountryTemplate = () => {
        return <InputText id="country" value={filterCountry} placeholder="Enter Country" onChange={(e) => setFilterCountry(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const HospitalFilterTemplate = () => {
        return <InputText id="hospital" value={filterHospitalName} placeholder="Enter Hospital" onChange={(e) => setFilterHospitalName(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    // const CompanyFilterTemplate = () => {
    //     return <InputText id="company" value={filterCompany} placeholder="Enter Company" onChange={(e) => setFilterCompany(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    // };

    const EmailFilterTemplate = () => {
        return <InputText id="Email" value={filterEmail} placeholder="Enter Email" onChange={(e) => setFilterEmail(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const MobileFilterTemplate = () => {
        return <InputText id="MobileNo" value={filterMobileNo} placeholder="Enter Mobile No." onChange={(e) => setFilterMobileNo(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const BoardingCityFilterTemplate = () => {
        return <InputText id="boardingcity" value={filterBoardingCity} placeholder="Enter Boarding City" onChange={(e) => setFilterBoardingCity(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const CompanyFilterTemplate = () => {
        return (
            <MultiSelect
                value={lazyState.current.CompanyFilter}
                options={companyList}
                itemTemplate={CompanyFilterItemTemplate}
                optionLabel="name"
                onChange={(e) => CompanyFilterClick(e)}
                placeholder="Select Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: "14rem" }}
                filter
            />
        );
    };

    const CompanyFilterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const CompanyFilterBodyTemplate = (rowData) => {
        const company = rowData.company;
        return (
            <div className="flex align-items-center gap-2">
                <span>{company}</span>
            </div>
        );
    };

    const CompanyFilterClick = (e) => {
        lazyState.current.CompanyFilter = e.target.value ? e.target.value : null;
        getparticipantlist(false, { CompanyFilter: e.value });
        e.preventDefault();
    };

    const TricoConfirmedFilterTemplate = () => {
        return (
            <MultiSelect
                value={lazyState.current.TricoConfirmedfilter}
                options={tricoConfirmedList}
                itemTemplate={TricoConfirmedFilterItemTemplate}
                optionLabel="name"
                onChange={(e) => TricoConfirmedFilterClick(e)}
                placeholder="Select Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: "14rem" }}
                filter
            />
        );
    };

    const TricoConfirmedFilterBodyTemplate = (rowData) => {
        const tricoConfirmed = rowData.tricoConfirmed;
        return (
            <div className="flex align-items-center gap-2">
                <span>{tricoConfirmed}</span>
            </div>
        );
    };
    const TricoConfirmedFilterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const TricoConfirmedFilterClick = (e) => {
        lazyState.current.TricoConfirmedfilter = e.target.value ? e.target.value : null;
        getparticipantlist(false, { TricoConfirmed: e.value });
        e.preventDefault();
    };
    const getData = () => {
        fetch("config.json", {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                setApiHeaders(data[1]);
                setWhatsAppUrlData(data[6].TicketWhatsAppUrl);
                setWhatsAppStatus(data[7].EnableWhatsApp);
                setSeemamamNo(data[8].SeemaMam);
                setcancelledTemplate(data[23].Cancelled_Template_Name);
                setEventMedium(data[15].Event_Name_Medium);
            });
    };
    //  TICKET CANCELLATION FOR IN, OUT, BOTH OR FULL
    const TicketCancellation = () => {
        setIsLoading(true);
        axios
            .put("/api/Participant/UpdateMultipleParticipantForCancellationById", {
                id: id.toString(),
                CancellationValue: Cancellationfor,
                TicketCancellationRemarks: CancellationRemarks ? CancellationRemarks : null,
            })
            .then((res) => {
                setIsLoading(false);
                setSelectedParticipant([]);
                setid([]);
                setActionDisable(true);
                setCancellationDialog(false);
                setCancellationfor(null);
                toast.current?.show({ severity: "success", summary: "Cancelled", detail: "Ticket Cancellation Request Sent To Travel Agent", life: 5000 });
                // document.documentElement.style.setProperty('overflow', 'auto');
                getparticipantlist(false, lazyState.current);
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current?.show({ severity: "error", summary: "Error", detail: "Oops! Something Went Wrong!", life: 3000 });
            });
    };
    const SendCancelledWhatsApp = () => {
        if (Cancellationfor == "Full") {
            userObj.forEach((element) => {
                var data = {
                    messaging_product: "whatsapp",
                    recipient_type: "individual",
                    to: element.mobileNo,
                    type: "template",
                    template: {
                        name: cancelledTemplate,
                        language: {
                            code: "en",
                        },
                        components: [
                            {
                                type: "body",
                                parameters: [
                                    {
                                        type: "text",
                                        text: element.fullName,
                                    },
                                    {
                                        type: "text",
                                        text: eventMedium,
                                    },
                                ],
                            },
                        ],
                    },
                };
                axios
                    .post("https://graph.facebook.com/v17.0/177696368765013/messages", data, ApiHeaders)
                    .then((res) => {
                        WhatsAppMessageStatus.current.Doctor = res.status;
                        WhatsAppLog(data, element?.id);
                    })
                    .catch((error) => {
                        WhatsAppMessageStatus.current.Doctor = error?.response?.status;
                    });
            });
        }
    };

    const SendCancelledWhatsAppToSeemaMam = () => {
        if (Cancellationfor == "Full") {
            userObj.forEach((element) => {
                var data = {
                    messaging_product: "whatsapp",
                    recipient_type: "individual",
                    to: SeemamamNo,
                    type: "template",
                    template: {
                        name: cancelledTemplate,
                        language: {
                            code: "en",
                        },
                        components: [
                            {
                                type: "body",
                                parameters: [
                                    {
                                        type: "text",
                                        text: element.fullName,
                                    },
                                    {
                                        type: "text",
                                        text: eventMedium,
                                    },
                                ],
                            },
                        ],
                    },
                };
                axios
                    .post("https://graph.facebook.com/v17.0/177696368765013/messages", data, ApiHeaders)
                    .then((res) => {
                        WhatsAppMessageStatus.current.Doctor = res.status;
                        WhatsAppLog(data, element?.id);
                    })
                    .catch((error) => {
                        WhatsAppMessageStatus.current.Doctor = error?.response?.status;
                    });
            });
        }
    };

    const SendCancelledWhatsAppToRegisteredBy = () => {
        if (Cancellationfor == "Full") {
            userObj.forEach((element) => {
                if (element.registeredby != null && element.companyphone != null) {
                    var data = {
                        messaging_product: "whatsapp",
                        recipient_type: "individual",
                        to: element.companyphone,
                        type: "template",
                        template: {
                            name: cancelledTemplate,
                            language: {
                                code: "en",
                            },
                            components: [
                                {
                                    type: "body",
                                    parameters: [
                                        {
                                            type: "text",
                                            text: element.fullName,
                                        },
                                        {
                                            type: "text",
                                            text: eventMedium,
                                        },
                                    ],
                                },
                            ],
                        },
                    };
                    axios
                        .post("https://graph.facebook.com/v17.0/177696368765013/messages", data, ApiHeaders)
                        .then((res) => {
                            WhatsAppMessageStatus.current.Doctor = res.status;
                            WhatsAppLog(data, element?.id);
                        })
                        .catch((error) => {
                            WhatsAppMessageStatus.current.Doctor = error?.response?.status;
                        });
                }
            });
        }
    };

    const WhatsAppLog = (Apidata, id) => {
        const url = "/api/Participant/WhatsAppLog";
        const data = {
            Number: Apidata?.to?.toString(),
            Template: Apidata.template.name,
            SendBy: UserName,
            AttendeeId: id.toString(),
            Screen: "TRAVEL-SUMMARY-FULL-CANCELLATION",
        };
        axios
            .post(url, data)
            .then((res) => {})
            .catch((error) => {
                console.log(error);
            });
    };

    const ButtonMailto = (rowData) => {
        return (
            <Link
                className="linkcolors"
                id="mailto"
                to="#"
                onClick={(e) => {
                    window.location.href = `mailto:${rowData.email}`;
                    e.preventDefault();
                }}
            >
                {rowData.email}
            </Link>
        );
    };

    const ButtonPhoneto = (rowData) => {
        return (
            <Link
                className="linkcolors"
                id="callto"
                to="#"
                onClick={(e) => {
                    window.location.href = `tel:${rowData.mobileNo}`;
                    e.preventDefault();
                }}
            >
                {rowData.mobileNo}
            </Link>
        );
    };

    const ViewAttendees = (rowData) => {
        return (
            <Link
                className="linkcolors"
                id="viewattendee"
                to="#"
                onClick={(e) => {
                    history.push("/home/viewparticipant/" + rowData.id);
                }}
            >
                {rowData.fullName}
            </Link>
        );
    };

    const removeFilter = () => {
        lazyState.current.fullName = null;
        setfullName(null);
        lazyState.current.filterHospitalName = null;
        setFilterHospitalName(null);
        lazyState.current.filterCompany = null;
        setFilterCompany(null);
        lazyState.current.filterDesignation = null;
        lazyState.current.filterGender = null;
        lazyState.current.filterEmail = null;
        setFilterEmail(null);
        lazyState.current.filterMobileNo = null;
        setFilterMobileNo(null);
        lazyState.current.filterCity = null;
        setFilterCity(null);
        lazyState.current.filterState = null;
        setFilterState(null);
        lazyState.current.filterCountry = null;
        setFilterCountry(null);
        lazyState.current.filterBoardingCity = null;
        setFilterBoardingCity(null);
        lazyState.current.filterInBatchBooking = null;
        setFilterInBatchBooking(null);
        lazyState.current.filterOutBatchBooking = null;
        setFilterOutBatchBooking(null);

        lazyState.current.serialnumber = null;
        setSerialNumber(null);

        lazyState.current.HotelFilter = null;
        setHotelFilter(null);

        lazyState.current.filterToEventCity = null;
        lazyState.current.filterFromEventCity = null;
        lazyState.current.filterOutFlightBookingStatus = null;
        lazyState.current.filterInFlightBookingStatus = null;
        lazyState.current.TricoConfirmedfilter = null;
        getparticipantlist(false, lazyState.current);
    };

    // Left Side Toolbar
    const leftToolbarTemplate = () => {
        return (
            <AccessControl allowedPermissions={["list:participant"]}>
                <div className="my-2 admin-toolbar-left">
                    <h4 className="headerfont m-auto mr-2">Count : {totalRecords}</h4>
                    <Button
                        disabled={ActionDisable}
                        label="Cancel Ticket (Inwards)"
                        icon="fa fa-times"
                        className="mr-2"
                        onClick={() => {
                            setCancellationDialog(true);
                            setCancellationfor("IN");
                        }}
                        outlined
                    />
                    <Button
                        disabled={ActionDisable}
                        label="Cancel Ticket (Outwards)"
                        icon="fa fa-times"
                        className="mr-2"
                        onClick={() => {
                            setCancellationDialog(true);
                            setCancellationfor("OUT");
                        }}
                        outlined
                    />
                    <Button
                        disabled={ActionDisable}
                        label="Cancel Ticket (BOTH)"
                        icon="fa fa-times"
                        className="mr-2"
                        onClick={() => {
                            setCancellationDialog(true);
                            setCancellationfor("BOTH");
                        }}
                        outlined
                    />
                    <Button
                        disabled={ActionDisable}
                        label="Full Cancellation"
                        icon="fa fa-times"
                        className="mr-2"
                        onClick={() => {
                            setCancellationDialog(true);
                            setCancellationfor("Full");
                        }}
                        outlined
                    />
                </div>
            </AccessControl>
        );
    };

    // Right Side Toolbar
    const rightToolbarTemplate = () => {
        return (
            <div className="my-2 admin-toolbar-right">
                <AccessControl allowedPermissions={["list:participant"]}>
                    <Button
                        icon="pi pi-filter"
                        label="Filter"
                        className="p-button-outlined mr-2 mobile-only-btn"
                        onClick={() => setFilterDialog(true)}
                        tooltip="Filter"
                        tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                        outlined
                    />
                    <Button
                        disabled={
                            lazyState.current.fullName == null &&
                            lazyState.current.filterHospitalName == null &&
                            lazyState.current.filterCompany == null &&
                            lazyState.current.filterDepartFrom == null &&
                            lazyState.current.filterArriveAt == null &&
                            lazyState.current.filterDesignation == null &&
                            lazyState.current.filterEmail == null &&
                            lazyState.current.filterMobileNo == null &&
                            lazyState.current.filterOutFlightBookingStatus == null &&
                            lazyState.current.filterInFlightBookingStatus == null &&
                            lazyState.current.filterInBatchBooking == null &&
                            lazyState.current.filterOutBatchBooking == null &&
                            lazyState.current.serialnumber == null &&
                            lazyState.current.HotelFilter == null &&
                            lazyState.current.filterCity == null &&
                            lazyState.current.filterCountry == null &&
                            lazyState.current.filterState == null &&
                            lazyState.current.filterBoardingCity == null &&
                            lazyState.current.TricoConfirmedfilter == null
                                ? true
                                : false
                        }
                        icon="pi pi-filter-slash"
                        className="p-button-outlined mr-2"
                        onClick={() => removeFilter()}
                        tooltip="Reset Filter"
                        tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                        outlined
                    ></Button>
                    {/* {enableFilter ? <Button type="button" icon="pi pi-filter-slash" tooltip="Hide Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} className=" mr-2 p-button-primary" onClick={(e) => setEnableFilter(false)} /> : <Button type="button" icon="pi pi-filter" tooltip="Show Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} className="p-button-outlined mr-2" onClick={(e) => setEnableFilter(true)} />} */}
                    <div className="my-2">{header}</div>
                </AccessControl>
                <AccessControl allowedPermissions={["export:participant"]}>
                    <Button
                        disabled={!(participantlist != null && participantlist.length > 0)}
                        tooltip="Export Excel"
                        tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                        onClick={() => {
                            getparticipantlist(true);
                        }}
                        icon="pi pi-file-excel"
                        className="mr-2"
                        outlined
                    />
                </AccessControl>
            </div>
        );
    };

    // Row Selection / Unselect Functions
    const onAllRowSelect = (e) => {
        setActionDisable(false);
        setid(
            e.data.map((i, k) => {
                return i.id;
            })
        );
        setUsrObj(
            e.data.map((i, k) => {
                return i;
            })
        );
    };

    const onRowSelect = (event) => {
        setActionDisable(false);
        setid((ing) => [...ing, event.data.id]);
        setUsrObj((ing) => [...ing, event.data]);
    };

    const onRowUnselect = (event) => {
        if (id != undefined) {
            var removeidfromdata = id.indexOf(event.data.id);
            var removedatafromobjbyid = userObj.indexOf(event.data.id);
            id.splice(removeidfromdata, 1);
            userObj.splice(removedatafromobjbyid, 1);
            if (id.length == 0) {
                setActionDisable(true);
            }
        } else {
            var removefromarray = id.indexOf(event.data.id);
            var removedatafromobjarray = userObj.indexOf(event.data.id);
            id.splice(removefromarray, 1);
            userObj.splice(removedatafromobjarray, 1);
        }
    };

    const onAllRowUnSelect = (e) => {
        setActionDisable(true);
        setid(
            e.data.map((i, k) => {
                return i.id;
            })
        );
        id.splice(0, id.length);
        userObj.splice(0, userObj.length);
    };

    //#region Method for Column toggle
    const hidecolumns = [
        // { field: "gender", header: "Gender" },
        // { field: "travelRemarks", header: "Travel Remarks" },
        { field: "designation", header: "Designation" },
        { field: "company", header: "Company" },
        { field: "hospitalName", header: "HospitalName" },
        { field: "email", header: "Email" },
        { field: "mobileNo", header: "Mobile No." },
        // { field: "inFlightBookingStatus", header: "In Flight Booking Status" },
        // { field: "outFlightBookingStatus", header: "Out Flight Booking Status" },
        // { field: "inBatchBooking", header: "In Batch Booking" },
        // { field: "outBatchBooking", header: "Out Batch Booking" },
        { field: "cityname", header: "City" },
        { field: "boardingcityname", header: "Boarding City" },
        { field: "statename", header: "State" },
        { field: "countryname", header: "Country" },
    ];

    let unSelectedColumns = [];
    const onColumnToggle = (event) => {
        let selectedColumns = event.value;
        let orderedSelectedColumns = hidecolumns.filter((col) => selectedColumns.some((sCol) => sCol.field === col.field));
        unSelectedColumns = hidecolumns.filter((o) => !selectedColumns.some((i) => i.field === o.field && i.header === o.header));
        unselectedColumnData();
        setSelectedColumns(orderedSelectedColumns);
    };

    const unselectedColumnData = () => {
        let isFiltered = false;
        if (unSelectedColumns) {
            unSelectedColumns.map((col) => {
                switch (col.header) {
                    case "Designation":
                        if (lazyState.current.filterDesignation != null) {
                            lazyState.current.filterDesignation = null;
                            isFiltered = true;
                            return lazyState.current.filterDesignation;
                        }
                        break;
                    case "Gender":
                        if (lazyState.current.filterGender != null) {
                            lazyState.current.filterGender = null;
                            isFiltered = true;
                            return lazyState.current.filterGender;
                        }
                        break;
                    case "Boarding City":
                        if (lazyState.current.filterBoardingCity != null) {
                            lazyState.current.filterBoardingCity = null;
                            isFiltered = true;
                            return setFilterBoardingCity(null);
                        }
                        break;
                    case "City":
                        if (lazyState.current.filterCity != null) {
                            lazyState.current.filterCity = null;
                            isFiltered = true;
                            return setFilterCity(null);
                        }
                        break;
                    case "State":
                        if (lazyState.current.filterState != null) {
                            lazyState.current.filterState = null;
                            isFiltered = true;
                            return setFilterState(null);
                        }
                        break;
                    case "Country":
                        if (lazyState.current.filterCountry != null) {
                            lazyState.current.filterCountry = null;
                            isFiltered = true;
                            return setFilterCountry(null);
                        }
                        break;

                    case "Out Flight Booking Status":
                        if (lazyState.current.filterOutFlightBookingStatus != null) {
                            lazyState.current.filterOutFlightBookingStatus = null;
                            isFiltered = true;
                            return lazyState.current.filterOutFlightBookingStatus;
                        }
                        break;
                    case "In Flight Booking Status":
                        if (lazyState.current.filterInFlightBookingStatus != null) {
                            lazyState.current.filterInFlightBookingStatus = null;
                            isFiltered = true;
                            return lazyState.current.filterInFlightBookingStatus;
                        }
                        break;
                    case "In Batch Booking":
                        if (lazyState.current.filterInBatchBooking != null) {
                            lazyState.current.filterInBatchBooking = null;
                            isFiltered = true;
                            return setFilterInBatchBooking(null);
                        }
                        break;
                    case "Out Batch Booking":
                        if (lazyState.current.filterOutBatchBooking != null) {
                            lazyState.current.filterOutBatchBooking = null;
                            isFiltered = true;
                            return setFilterOutBatchBooking(null);
                        }
                        break;
                }
            });
            if (isFiltered) {
                getparticipantlist(false, lazyState.current);
            }
        }
    };

    const header = (
        <div className="more-columns-multiselect" style={{ textAlign: "left" }}>
            <MultiSelect className="more-columns-multiselect" value={selectedColumns} options={hidecolumns} optionLabel="header" placeholder="More Columns" onChange={onColumnToggle} display="chip" />
        </div>
    );

    const hideColumnsFilterTemplate = (column) => {
        switch (column) {
            case "Designation":
                return DesignationFilterTemplate;
            case "Company":
                return CompanyFilterTemplate;
            case "HospitalName":
                return HospitalFilterTemplate;
            case "Email":
                return EmailFilterTemplate;
            case "Mobile No.":
                return MobileFilterTemplate;
            // case "Gender":
            //     return GenderFilterTemplate;
            case "City":
                return CityTemplate;
            case "Boarding City":
                return BoardingCityFilterTemplate;
            case "State":
                return StateTemplate;
            case "Country":
                return CountryTemplate;
            // case "Out Flight Booking Status":
            //     return OutFlightBookingFilterTemplate;
            // case "In Flight Booking Status":
            //     return InFlightBookingFilterTemplate;
            // case "In Batch Booking":
            //     return InBatchBookingFilterTemplate;
            // case "Out Batch Booking":
            //     return OutBatchBookingFilterTemplate;
        }
    };

    const sortColumn = {
        // "City" : 'CityId',
        // "Boarding City": 'Boardingcity',
        // "Gender": 'Gender',
        Designation: "Designation",
        "In Flight Booking Status": "InFlightBookingStatus",
        "Out Flight Booking Status": "OutFlightBookingStatus",
        "In Batch Booking": "InBatchBooking",
        "Out Batch Booking": "OutBatchBooking",
        HospitalName: "HospitalName",
    };

    const hidecolumnComponents = selectedColumns.map((col) => {
        return (
            <Column
                key={col.field}
                field={col.field}
                header={col.header}
                sortable
                headerStyle={{ width: "15%", minWidth: "16rem" }}
                sortField={sortColumn[col.header]}
                filter
                showFilterMenu={false}
                filterElement={hideColumnsFilterTemplate(col.header)}
                body={col.header == "Email" ? ButtonMailto : col.header == "Mobile No." ? ButtonPhoneto : null}
            />
        );
    });

    const ViewAttendeeIcon = (rowData) => {
        return (
            <div className="actions">
                <Link to="#" onClick={(e) => history.push({ pathname: "/home/viewattendeeRecord/" + rowData.id, state: { detail: "TravelSummary" } })}>
                    {" "}
                    <span className={usrDetails?.role == "ADMIN" || usrDetails?.role == "ITADMIN" ? "fa fa-solid fa-eye" : "hidden"} id="viewattendeerecord" style={{ color: " rgb(42, 102, 151)" }}></span>
                </Link>
            </div>
        );
    };

    const CancellationDialogFooter = (
        <>
            <Button
                label="Save"
                icon="fa fa-check"
                outlined
                onClick={() => {
                    TicketCancellation();
                    SendCancelledWhatsApp();
                    SendCancelledWhatsAppToSeemaMam();
                    SendCancelledWhatsAppToRegisteredBy();
                }}
            />
            <Button label="Cancel" icon="fa fa-times" onClick={(e) => hideDialog(e)} outlined />
        </>
    );

    const hideDialog = () => {
        // document.documentElement.style.setProperty('overflow', 'auto');
        setCancellationDialog(false);
        setCancellationfor(null);
    };
    //#endregion

    const SearchFilter = () => {
        lazyState.current.fullName = fullName ? fullName : null;
        lazyState.current.filterHospitalName = filterHospitalName ? filterHospitalName : null;
        lazyState.current.filterCompany = filterCompany ? filterCompany : null;
        lazyState.current.filterEmail = filterEmail ? filterEmail : null;
        lazyState.current.filterMobileNo = filterMobileNo ? filterMobileNo : null;
        lazyState.current.filterCity = filterCity ? filterCity : null;
        lazyState.current.filterState = filterState ? filterState : null;
        lazyState.current.filterCountry = filterCountry ? filterCountry : null;
        lazyState.current.filterBoardingCity = filterBoardingCity ? filterBoardingCity : null;
        lazyState.current.filterInBatchBooking = filterInBatchBooking ? filterInBatchBooking : null;
        lazyState.current.filterOutBatchBooking = filterOutBatchBooking ? filterOutBatchBooking : null;
        lazyState.current.serialnumber = SerialNumber ? SerialNumber : null;
        lazyState.current.HotelFilter = HotelFilter ? HotelFilter : null;
        getparticipantlist(false, lazyState.current);
        setFilterDialog(false);
    };

    const filterDialogFooter = (
        <div className="filter-modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '0.5rem' }}>
            <Button
                label="Reset"
                icon="pi pi-filter-slash"
                className="p-button-outlined p-button-secondary"
                onClick={() => {
                    removeFilter();
                    setFilterDialog(false);
                }}
                outlined
            />
            <Button
                label="Apply"
                icon="pi pi-check"
                className="p-button-primary"
                onClick={() => SearchFilter()}
            />
        </div>
    );

    return (
        <>
            <Toast ref={toast} />
            <AccessControl allowedPermissions={["list:participant"]} renderNoAccess={() => <NoAccess />}>
                <div className="trico-Grid">
                    {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <div className="p-col">
                            <div className="card">
                                <h5 className="headerfont">
                                    <span>
                                        <i className="fa fa-solid  fa-plane fa-rotate-110 mr-2"></i>Travel Summary
                                    </span>
                                </h5>
                                <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3"></Toolbar>
                                <Tooltip target="#viewattendee" content="View / Edit Attendee" />
                                <Tooltip target="#mailto" content="Mail To" />
                                <Tooltip target="#callto" content="Call To" />
                                <Tooltip target="#viewattendeerecord" content="View Attendee Record" />
                                <div className="attendee-status-desktop-table">
                                    <DataTable
                                        size="small"
                                        stripedRows
                                        ref={dt}
                                        value={participantlist}
                                        lazy
                                        rows={lazyState.current.rows}
                                        scrollable
                                        scrollHeight="calc(100vh - 250px)"
                                        onSort={onSort}
                                        sortField={lazyState.current.sortField}
                                        sortOrder={lazyState.current.sortOrder}
                                        removableSort
                                        selectionMode={"checkbox"}
                                        onAllRowsSelect={onAllRowSelect}
                                        selection={selectedParticipant}
                                        onSelectionChange={(e) => setSelectedParticipant(e.value)}
                                        onRowSelect={onRowSelect}
                                        onRowUnselect={onRowUnselect}
                                        onAllRowsUnselect={onAllRowUnSelect}
                                        dataKey="id"
                                        className="datatable-responsive"
                                        responsiveLayout="scroll"
                                        filterDisplay={"row"}
                                    >
                                        <Column body={ViewAttendeeIcon} frozen exportable={true} headerStyle={{ width: "0%", minWidth: "2rem" }}></Column>
                                        <Column frozen selectionMode="multiple" headerStyle={{ width: "0%", minWidth: "1rem" }}></Column>
                                        <Column alignFrozen="left" field="serialNumber" header="Id" sortField="SerialNumber" sortable frozen headerStyle={{ width: "3%", minWidth: "5rem" }} filter showFilterMenu={false} filterElement={SerialNumberFilterTemplate} showClearButton></Column>
                                        <Column body={ViewAttendees} frozen sortField="FullName" field="fullName" header="Name" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} filter showFilterMenu={false} filterElement={UserFilterTemplate} showClearButton></Column>
                                        <Column
                                            field="company"
                                            header="Company"
                                            sortField="company"
                                            sortable
                                            headerStyle={{ width: "25%", minWidth: "15rem" }}
                                            style={{ overflowWrap: "anywhere" }}
                                            filter
                                            showFilterMenu={false}
                                            filterElement={CompanyFilterTemplate}
                                            body={CompanyFilterBodyTemplate}
                                            filterField="Company"
                                            filterMenuStyle={{ width: "14rem" }}
                                        ></Column>
                                        <Column
                                            field="tricoConfirmed"
                                            sortField="TricoConfirmed"
                                            sortable
                                            header="Trico Confirmed"
                                            headerStyle={{ width: "10%", minWidth: "15rem" }}
                                            style={{ overflowWrap: "anywhere" }}
                                            filter
                                            showFilterMenu={false}
                                            filterElement={TricoConfirmedFilterTemplate}
                                            body={TricoConfirmedFilterBodyTemplate}
                                            filterField="tricoConfirmed"
                                            filterMenuStyle={{ width: "14rem" }}
                                        ></Column>
                                        <Column field="hotelName" sortField="HotelName" header="Hotel" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} filter showFilterMenu={false} filterElement={HotelFilterTemplate} style={{ overflowWrap: "anywhere" }}></Column>
                                        <Column
                                            field="inFlightBookingStatus"
                                            sortField="InFlightBookingStatus"
                                            header="In Flight Booking Status"
                                            sortable
                                            headerStyle={{ width: "15%", minWidth: "15rem" }}
                                            filter
                                            showFilterMenu={false}
                                            filterElement={InFlightBookingFilterTemplate}
                                            showClearButton
                                        ></Column>
                                        <Column
                                            field="outFlightBookingStatus"
                                            sortField="OutFlightBookingStatus"
                                            header="Out Flight Booking Status"
                                            sortable
                                            headerStyle={{ width: "15%", minWidth: "15rem" }}
                                            filter
                                            showFilterMenu={false}
                                            filterElement={OutFlightBookingFilterTemplate}
                                            showClearButton
                                        ></Column>
                                        <Column field="inBatchBooking" sortField="InBatchBooking" header="In Batch Booking" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} filter showFilterMenu={false} filterElement={InBatchBookingFilterTemplate} showClearButton></Column>
                                        <Column field="outBatchBooking" sortField="OutBatchBooking" header="Out Batch Booking" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} filter showFilterMenu={false} filterElement={OutBatchBookingFilterTemplate} showClearButton></Column>
                                        {hidecolumnComponents}
                                    </DataTable>
                                </div>
                                <div className="attendee-status-mobile-cards">
                                    {participantlist && participantlist.length > 0 && (
                                        <div className="mobile-select-all-bar mb-2">
                                            <Checkbox
                                                inputId="selectAllMobileTravel"
                                                onChange={(e) => {
                                                    if (e.checked) {
                                                        setSelectedParticipant([...participantlist]);
                                                    } else {
                                                        setSelectedParticipant([]);
                                                    }
                                                }}
                                                checked={
                                                    participantlist.length > 0 &&
                                                    selectedParticipant &&
                                                    participantlist.every((item) =>
                                                        selectedParticipant.some((p) => p.id === item.id)
                                                    )
                                                }
                                            />
                                            <label htmlFor="selectAllMobileTravel" className="font-semibold cursor-pointer">
                                                Select All ({selectedParticipant?.length || 0}/{totalRecords})
                                            </label>
                                        </div>
                                    )}
                                    <div className="attendee-card-grid">
                                        {participantlist && participantlist.length > 0 ? (
                                            participantlist.map((row) => {
                                                const isSelected = selectedParticipant && selectedParticipant.some((p) => p.id === row.id);
                                                const handleCardCheckbox = (e) => {
                                                    let _selected = selectedParticipant ? [...selectedParticipant] : [];
                                                    if (e.checked) {
                                                        _selected.push(row);
                                                    } else {
                                                        _selected = _selected.filter((p) => p.id !== row.id);
                                                    }
                                                    setSelectedParticipant(_selected);
                                                };
                                                return (
                                                    <div key={row.id} className={`attendee-mobile-card ${isSelected ? "attendee-card-selected" : ""}`}>
                                                        {/* Top header with Checkbox, Id, Trico Confirmed, Company, and Action */}
                                                        <div className="attendee-card-top flex justify-content-between align-items-center mb-2">
                                                            <div className="attendee-card-top-left flex flex-wrap align-items-center gap-2">
                                                                <Checkbox checked={isSelected} onChange={handleCardCheckbox} className="attendee-card-checkbox" />
                                                                <span className="attendee-card-id">#{row.serialNumber || "-"}</span>
                                                                {row.tricoConfirmed && (
                                                                    <span className="attendee-trico-tag">{row.tricoConfirmed}</span>
                                                                )}
                                                                {row.company && (
                                                                    <span className="attendee-company-badge">
                                                                        <i className="fa fa-building-o mr-1"></i>
                                                                        {row.company}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <div className="attendee-card-top-right flex align-items-center">
                                                                {ViewAttendeeIcon(row)}
                                                            </div>
                                                        </div>

                                                        {/* Full Name */}
                                                        <h6 className="attendee-card-name font-bold mb-2">
                                                            {ViewAttendees(row)}
                                                        </h6>

                                                        {/* Designation & Qualification */}
                                                        {(row.designation || row.qualification) && (
                                                            <div className="attendee-card-subinfo text-sm mb-2 text-600">
                                                                {row.designation && <span className="designation-pill">{row.designation}</span>}
                                                                {row.qualification && <span className="text-500 font-medium ml-1">({row.qualification})</span>}
                                                            </div>
                                                        )}

                                                        {/* In & Out Batch Row */}
                                                        {(row.inBatchBooking || row.outBatchBooking) && (
                                                            <div className="attendee-batch-row flex flex-wrap align-items-center gap-2 mb-2">
                                                                {row.inBatchBooking && (
                                                                    <span className="batch-tag">
                                                                        <i className="fa fa-sign-in mr-1 text-primary"></i><b>In:</b> {row.inBatchBooking}
                                                                    </span>
                                                                )}
                                                                {row.outBatchBooking && (
                                                                    <span className="batch-tag">
                                                                        <i className="fa fa-sign-out mr-1 text-orange-500"></i><b>Out:</b> {row.outBatchBooking}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )}

                                                        {/* Status Badges Row */}
                                                        {(row.inFlightBookingStatus || row.outFlightBookingStatus) && (
                                                            <div className="attendee-status-badges flex flex-wrap align-items-center gap-2 mb-2">
                                                                {row.inFlightBookingStatus && (
                                                                    <span className={`status-pill ${row.inFlightBookingStatus === "Booked" ? "status-pill-yes" : "status-pill-neutral"}`}>
                                                                        <i className="fa fa-plane mr-1"></i>In Flight: {row.inFlightBookingStatus}
                                                                    </span>
                                                                )}
                                                                {row.outFlightBookingStatus && (
                                                                    <span className={`status-pill ${row.outFlightBookingStatus === "Booked" ? "status-pill-yes" : "status-pill-neutral"}`}>
                                                                        <i className="fa fa-plane fa-rotate-180 mr-1"></i>Out Flight: {row.outFlightBookingStatus}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )}

                                                        {/* Details Section */}
                                                        <div className="attendee-card-details">
                                                            {(row.mobileNo || row.email) && (
                                                                <div className="attendee-detail-row">
                                                                    {row.mobileNo && (
                                                                        <div className="attendee-detail-item">
                                                                            <i className="fa fa-phone text-500 mr-1"></i>
                                                                            <a href={`tel:${row.mobileNo}`} className="linkcolors text-sm">{row.mobileNo}</a>
                                                                        </div>
                                                                    )}
                                                                    {row.email && (
                                                                        <div className="attendee-detail-item">
                                                                            <i className="fa fa-envelope-o text-500 mr-1"></i>
                                                                            <a href={`mailto:${row.email}`} className="linkcolors text-sm">{row.email}</a>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                            {(row.hotelName || row.hospitalName || row.cityname || row.boardingcityname) && (
                                                                <div className="attendee-detail-row">
                                                                    {row.hotelName && (
                                                                        <div className="attendee-detail-item">
                                                                            <i className="fa fa-bed text-500 mr-1"></i>
                                                                            <span className="text-sm">Hotel: {row.hotelName}</span>
                                                                        </div>
                                                                    )}
                                                                    {row.hospitalName && (
                                                                        <div className="attendee-detail-item">
                                                                            <i className="fa fa-hospital-o text-500 mr-1"></i>
                                                                            <span className="text-sm">Hospital: {row.hospitalName}</span>
                                                                        </div>
                                                                    )}
                                                                    {row.boardingcityname && (
                                                                        <div className="attendee-detail-item">
                                                                            <i className="fa fa-map-marker text-500 mr-1"></i>
                                                                            <span className="text-sm">Boarding: {row.boardingcityname}</span>
                                                                        </div>
                                                                    )}
                                                                    {row.cityname && (
                                                                        <div className="attendee-detail-item">
                                                                            <i className="fa fa-map-marker text-500 mr-1"></i>
                                                                            <span className="text-sm">City: {row.cityname}</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="attendee-empty-state text-center p-4 card surface-card">
                                                <i className="fa fa-inbox text-4xl text-400 mb-2"></i>
                                                <p className="text-600 m-0">No records found</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <Paginator
                                    className="justify-content-end admin-paginator"
                                    first={lazyState.current.first}
                                    rows={lazyState.current.rows}
                                    totalRecords={totalRecords}
                                    template={template2}
                                    rowsPerPageOptions={RowsPerPageDropdown}
                                    onPageChange={onBasicPageChange}
                                ></Paginator>

                                <Dialog
                                    visible={CancellationDialog}
                                    draggable={false}
                                    style={{ width: "450px" }}
                                    header="Cancellation Remarks"
                                    modal
                                    className="p-fluid"
                                    footer={CancellationDialogFooter}
                                    onHide={(e) => hideDialog(e)}
                                >
                                    <div className="field">
                                        <label id="label">Cancellation Remarks</label>
                                        <InputText maxLength="100" autoFocus placeholder="Enter Cancellation Remarks" value={CancellationRemarks} onChange={(e) => setCancellationRemarks(e.target.value)} />
                                    </div>
                                </Dialog>

                                <Dialog
                                    visible={filterDialog}
                                    draggable={false}
                                    header={
                                        <div className="dialog-header-content flex align-items-center gap-2">
                                            <i className="fa fa-filter text-primary dialog-header-icon mr-2"></i>
                                            <span className="dialog-header-title">Filter Travel Summary</span>
                                        </div>
                                    }
                                    modal
                                    className="p-fluid admin-dialog attendee-filter-dialog"
                                    footer={filterDialogFooter}
                                    onHide={() => setFilterDialog(false)}
                                >
                                    <div className="filter-dialog-grid">
                                        <div className="filter-field-item">
                                            <label>Sr No.</label>
                                            <InputText value={SerialNumber} placeholder="Sr No." onChange={(e) => setSerialNumber(e.target.value)} />
                                        </div>
                                        <div className="filter-field-item">
                                            <label>Name</label>
                                            <InputText value={fullName} placeholder="Enter FirstName" onChange={(e) => setfullName(e.target.value)} />
                                        </div>
                                        <div className="filter-field-item">
                                            <label>Company</label>
                                            <MultiSelect
                                                value={lazyState.current.CompanyFilter}
                                                options={companyList}
                                                itemTemplate={CompanyFilterItemTemplate}
                                                optionLabel="name"
                                                onChange={(e) => {
                                                    lazyState.current.CompanyFilter = e.target.value ? e.target.value : null;
                                                }}
                                                placeholder="Select Company"
                                                maxSelectedLabels={1}
                                                filter
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label>Trico Confirmed</label>
                                            <MultiSelect
                                                value={lazyState.current.TricoConfirmedfilter}
                                                options={tricoConfirmedList}
                                                itemTemplate={TricoConfirmedFilterItemTemplate}
                                                optionLabel="name"
                                                onChange={(e) => {
                                                    lazyState.current.TricoConfirmedfilter = e.target.value ? e.target.value : null;
                                                }}
                                                placeholder="Select Trico Confirmed"
                                                maxSelectedLabels={1}
                                                filter
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label>Hotel</label>
                                            <InputText value={HotelFilter} placeholder="Enter Hotel" onChange={(e) => setHotelFilter(e.target.value)} />
                                        </div>
                                        <div className="filter-field-item">
                                            <label>In Flight Booking Status</label>
                                            <Dropdown
                                                value={lazyState.current.filterInFlightBookingStatus}
                                                options={FlightBookingStatus.BookingStatus}
                                                optionLabel="name"
                                                showClear
                                                onChange={(e) => {
                                                    lazyState.current.filterInFlightBookingStatus = e.target.value ? e.target.value : null;
                                                }}
                                                placeholder="Select InFlight Status"
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label>Out Flight Booking Status</label>
                                            <Dropdown
                                                value={lazyState.current.filterOutFlightBookingStatus}
                                                options={FlightBookingStatus.BookingStatus}
                                                optionLabel="name"
                                                showClear
                                                onChange={(e) => {
                                                    lazyState.current.filterOutFlightBookingStatus = e.target.value ? e.target.value : null;
                                                }}
                                                placeholder="Select OutFlight Status"
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label>In Batch Booking</label>
                                            <InputText value={filterInBatchBooking} placeholder="Enter InBatch Booking" onChange={(e) => setFilterInBatchBooking(e.target.value)} />
                                        </div>
                                        <div className="filter-field-item">
                                            <label>Out Batch Booking</label>
                                            <InputText value={filterOutBatchBooking} placeholder="Enter OutBatch Booking" onChange={(e) => setFilterOutBatchBooking(e.target.value)} />
                                        </div>
                                        {selectedColumns.some((c) => c.field === "designation") && (
                                            <div className="filter-field-item">
                                                <label>Designation</label>
                                                <Dropdown
                                                    value={lazyState.current.filterDesignation}
                                                    options={Designations.Designation}
                                                    optionLabel="name"
                                                    showClear
                                                    onChange={(e) => {
                                                        lazyState.current.filterDesignation = e.target.value ? e.target.value : null;
                                                    }}
                                                    placeholder="Select Designation"
                                                />
                                            </div>
                                        )}
                                        {selectedColumns.some((c) => c.field === "hospitalName") && (
                                            <div className="filter-field-item">
                                                <label>Hospital</label>
                                                <InputText value={filterHospitalName} placeholder="Enter Hospital" onChange={(e) => setFilterHospitalName(e.target.value)} />
                                            </div>
                                        )}
                                        {selectedColumns.some((c) => c.field === "email") && (
                                            <div className="filter-field-item">
                                                <label>Email</label>
                                                <InputText value={filterEmail} placeholder="Enter Email" onChange={(e) => setFilterEmail(e.target.value)} />
                                            </div>
                                        )}
                                        {selectedColumns.some((c) => c.field === "mobileNo") && (
                                            <div className="filter-field-item">
                                                <label>Mobile No.</label>
                                                <InputText value={filterMobileNo} placeholder="Enter Mobile No." onChange={(e) => setFilterMobileNo(e.target.value)} />
                                            </div>
                                        )}
                                        {selectedColumns.some((c) => c.field === "cityname") && (
                                            <div className="filter-field-item">
                                                <label>City</label>
                                                <InputText value={filterCity} placeholder="Enter City" onChange={(e) => setFilterCity(e.target.value)} />
                                            </div>
                                        )}
                                        {selectedColumns.some((c) => c.field === "boardingcityname") && (
                                            <div className="filter-field-item">
                                                <label>Boarding City</label>
                                                <InputText value={filterBoardingCity} placeholder="Enter Boarding City" onChange={(e) => setFilterBoardingCity(e.target.value)} />
                                            </div>
                                        )}
                                        {selectedColumns.some((c) => c.field === "statename") && (
                                            <div className="filter-field-item">
                                                <label>State</label>
                                                <InputText value={filterState} placeholder="Enter State" onChange={(e) => setFilterState(e.target.value)} />
                                            </div>
                                        )}
                                    </div>
                                </Dialog>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </AccessControl>
        </>
    );
};

export default TravelSummary;
